module.exports = "https://99designs-start-assets.imgix.net/js/43f7cd27da0f23ecbc08ef0218f985bf.png";